const ClassGfip = Object.freeze({
    '1': 'Não ensejador de aposentadoria especial',
    '2': 'Ensejador de aposentadoria especial - FAE15_12% (15 anos de contribuição e alíquota de 12%)',
    '3': 'Ensejador de aposentadoria especial - FAE20_09% (20 anos de contribuição e alíquota de 9%)',
    '4': 'Ensejador de aposentadoria especial - FAE25_06% (25 anos de contribuição e alíquota de 6%)'
})

export default ClassGfip;